import {Component, Input, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {
  FetchCoachesFilterRequest,
  FetchParticipantAttendanceRequest
} from "../../core/sessions-list.actions";
import {participantAttendanceInfo} from "../../core/sessions-list.selectors";
import {Subject, takeUntil} from "rxjs";
import * as moment from 'moment';
import {roles} from "../../../../shared/constants/common.constants";

@Component({
  selector: 'app-individual-session-details',
  templateUrl: './individual-session-details.component.html',
  styleUrls: ['./individual-session-details.component.css']
})
export class IndividualSessionDetailsComponent implements OnInit {
  @Input() data

  user: any;
  userList: any = [];
  loading: boolean = false;
  sessionDetails: any;
  sessionId: any;
  groupId: any;
  sessionCompleted: boolean;
  participantAttendanceInfo: any;
  groupStatus: number = 0;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store,
  ) {

  }

  ngOnInit() {

    this.store.dispatch(FetchCoachesFilterRequest({payload: {clientId: this.data.clientId}}));
    this.sessionDetails = this.data?.sessionDetails
    this.groupId = this.data?.groupId
    this.sessionId = this.data?.sessionId;
    this.groupStatus = this.data?.groupStatus;
    this.sessionCompleted = this.data?.sessionCompleted


    const payload = {
      groupId: this.groupId,
      participantId: this.sessionDetails.id,
      sessionId: this.sessionId
    }
    this.store.dispatch(FetchParticipantAttendanceRequest({payload}))

    this.store.select(participantAttendanceInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.loading = data.loading;
        this.participantAttendanceInfo = data?.data

        this.user = {
          id: this.participantAttendanceInfo?.id,
          name: this.participantAttendanceInfo?.name,
          participantName: this.participantAttendanceInfo?.participantName,
          type: this.participantAttendanceInfo?.roleName,
          role: roles.participant,
          relationWithParticipant: this.participantAttendanceInfo?.relationWithParticipant || '',
          age: this.calculateAge(this.participantAttendanceInfo?.dob),
          isLar: this.participantAttendanceInfo?.isLar || null,
          isOpen: false,
          isPresent: this.participantAttendanceInfo?.isPresent,
          sessionData: {
            ...this.participantAttendanceInfo?.sessionData,
            groupCoaches: this.participantAttendanceInfo?.groupCoaches
          }
        }

        this.userList = [this.user];

        this.participantAttendanceInfo?.adultsAttendance?.forEach(eachAdult => {
          const adult = {
            id: eachAdult?.id,
            name: `${eachAdult?.firstName} ${eachAdult?.lastName}`,
            type: 'Adult',
            role: roles.adult,
            relationWithParticipant: eachAdult?.relation,
            isOtherRelation: eachAdult?.isOtherRelation || false,
            age: this.calculateAge(eachAdult?.dob),
            isLar: eachAdult?.isLar,
            isOpen: false,
            isPresent: eachAdult?.isPresent,
            sessionData: {
              ...eachAdult?.sessionData,
              groupCoaches: this.participantAttendanceInfo?.groupCoaches
            }
          }
          this.userList = [
            ...this.userList,
            adult
          ]
        })
      })

  }

  calculateAge(dob) {
    const birthdate = moment(dob);
    const currentDate = moment(moment());
    return currentDate.diff(birthdate, 'years')
  }

}
